var _rect, _rect2, _path, _circle, _rect3, _path2, _rect4, _circle2, _circle3, _circle4, _circle5, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIcSearchWallet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 90,
    viewBox: "0 0 120 90",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.17415,
    y: 15.0168,
    width: 71.7489,
    height: 43.0919,
    rx: 7,
    transform: "rotate(-11.1241 1.17415 15.0168)",
    fill: "url(#paint0_linear_2450_6203)",
    stroke: "url(#paint1_linear_2450_6203)",
    strokeWidth: 2
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 14,
    width: 82,
    height: 61,
    rx: 7,
    fill: "url(#paint2_linear_2450_6203)",
    stroke: "url(#paint3_linear_2450_6203)",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M49.5 38H83V55H49.5C44.8056 55 41 51.1944 41 46.5C41 41.8056 44.8056 38 49.5 38Z",
    fill: "#131245",
    stroke: "url(#paint4_linear_2450_6203)",
    strokeWidth: 2
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 47,
    r: 5,
    fill: "#03F5AE"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 96.3887,
    y: 67.2295,
    width: 7.98992,
    height: 27.395,
    rx: 3,
    transform: "rotate(-36.935 96.3887 67.2295)",
    fill: "#D9D9D9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M98.1914 69.6274C97.1958 68.3031 97.4623 66.4224 98.7866 65.4268L100.377 64.231C101.702 63.2354 103.582 63.5019 104.578 64.8262L116.493 80.6753L110.106 85.4765L98.1914 69.6274Z",
    fill: "#2E366B"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 95.7344,
    y: 64.123,
    width: 4.78243,
    height: 3.45348,
    transform: "rotate(-37.0517 95.7344 64.123)",
    fill: "#D9D9D9"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 86,
    cy: 47,
    r: 19,
    fill: "url(#paint5_linear_2450_6203)",
    stroke: "url(#paint6_linear_2450_6203)",
    strokeWidth: 2
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 81,
    cy: 48,
    r: 2,
    fill: "#03F5AE"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 87,
    cy: 48,
    r: 2,
    fill: "#03F5AE"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 93,
    cy: 48,
    r: 2,
    fill: "#03F5AE"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2450_6203",
    x1: 73.7489,
    y1: 40.711,
    x2: -0.00000227687,
    y2: 40.711,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9393AA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#090936"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2450_6203",
    x1: 75.5048,
    y1: 38.9217,
    x2: 0.00000202602,
    y2: 38.9217,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#404066"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#292962"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2450_6203",
    x1: 84,
    y1: 50,
    x2: -0.00000259336,
    y2: 50,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#202044"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9797AE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2450_6203",
    x1: 86,
    y1: 47.5,
    x2: 0.00000230764,
    y2: 47.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#404066"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#292962"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_2450_6203",
    x1: 40,
    y1: 46.6508,
    x2: 84,
    y2: 46.6508,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#404066"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E0E2B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_2450_6203",
    x1: 74.5,
    y1: 29.5,
    x2: 104,
    y2: 55,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#42426A",
    stopOpacity: 0.99
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A5A5B3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_2450_6203",
    x1: 66,
    y1: 47.3175,
    x2: 106,
    y2: 47.3175,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#787898"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#26265C"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcSearchWallet);
export default __webpack_public_path__ + "static/media/ic-search-wallet.de600d3e7577c1d6089a3806aade85e2.svg";
export { ForwardRef as ReactComponent };